export const getNumberDays = (date, months) => {
    const end = new Date(date);
    end.setMonth(end.getMonth() + months);
    const timeDifference = end - new Date(date); // Difference in milliseconds
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24); // Convert to days
    return daysDifference;
};

export const convertDateType = (originDate) => {
    const date = new Date(new Date(originDate).toISOString().split('T')[0]);
    return date.toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
    });
};

export const convertDateTime = (originDate) => {
    const date = new Date(new Date(originDate).toISOString().split('T')[0]);
    return date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        // second: "2-digit",
        hour12: false // Set to true for AM/PM format
    });
};

export const getBeforeDate = (date, months) => {
    const end = new Date(date);
    end.setMonth(end.getMonth() - months);
    return end;
};

export const boldText = (text) => {
    const regexPattern = /\*\*(.*?)\*\*/g;
    const parts = [];
    let lastIndex = 0;
    text.replace(regexPattern, (match, boldWord, index) => {
        parts.push(text.substring(lastIndex, index));
        parts.push(<strong key={index}>{boldWord}</strong>);
        lastIndex = index + match.length;
    });
    parts.push(text.substring(lastIndex));
    return <p>{parts}</p>;
};

export const lightenColor = (hex, percent) => {
    hex = hex.replace(/^#/, '');

    if (hex.length === 3) {
        hex = hex
            .split('')
            .map((h) => h + h)
            .join('');
    }

    const num = parseInt(hex, 16);
    let r = (num >> 16) + Math.round(2.55 * percent);
    let g = ((num >> 8) & 0x00ff) + Math.round(2.55 * percent);
    let b = (num & 0x0000ff) + Math.round(2.55 * percent);

    r = Math.min(255, Math.max(0, r));
    g = Math.min(255, Math.max(0, g));
    b = Math.min(255, Math.max(0, b));

    return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
};

export const calculatePopupPosition = (clickX, clickY, popupHeight = 472, popupWidth = 273, viewportMargin = 10) => {
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    // Adjust Left position
    let finalLeft = clickX;
    if (clickX + popupWidth > viewportWidth - viewportMargin) {
        finalLeft = viewportWidth - popupWidth - viewportMargin;
    }
    finalLeft = Math.max(viewportMargin, finalLeft);

    // Adjust Top position
    let finalTop = clickY;
    if (clickY + popupHeight > viewportHeight - viewportMargin) {
        finalTop = viewportHeight - popupHeight - viewportMargin;
    }
    finalTop = Math.max(viewportMargin, finalTop);

    return { left: finalLeft, top: finalTop };
};
